import { propelyApi } from "@libs/firebase/api";
import { ICreateFolderMutation, IMoveFilesMutation, TApiGetCollectionItemFoldersResponse, TApiGetFilesResponse } from "@propely/propely-typings";

export type PropertyCollectionItemEntriesInput = {
  propertyId: string;
  collectionId: string;
  itemId: string;
  folderId?: string;
};

export const getAllPropertyCollectionItemFiles = ({
  propertyId,
  collectionId,
  itemId,
}: {
  propertyId: string;
  collectionId: string;
  itemId: string;
}) => {
  console.log("Fetching files", propertyId, collectionId, itemId);
  return propelyApi()
    .get(`/properties/${propertyId}/collections/${collectionId}/items/${itemId}/files`)
    .then((response) => TApiGetFilesResponse.parse(response.data));
};

export const getPropertyCollectionItemFiles = ({ propertyId, collectionId, itemId, folderId }: PropertyCollectionItemEntriesInput) => {
  return (
    folderId
      ? propelyApi().get(`/properties/${propertyId}/collections/${collectionId}/items/${itemId}/folders/${folderId}/files`)
      : propelyApi().get(`/properties/${propertyId}/collections/${collectionId}/items/${itemId}/rootFiles`)
  ).then((response) => TApiGetFilesResponse.parse(response.data));
};

export const getPropertyCollectionItemFolders = ({ propertyId, collectionId, itemId, folderId }: PropertyCollectionItemEntriesInput) => {
  return (
    folderId
      ? propelyApi().get(`/properties/${propertyId}/collections/${collectionId}/items/${itemId}/folders/${folderId}/folders`)
      : propelyApi().get(`/properties/${propertyId}/collections/${collectionId}/items/${itemId}/folders`)
  ).then((response) => TApiGetCollectionItemFoldersResponse.parse(response.data));
};

export type CreatePropertyCollectionItemFolderInput = Omit<PropertyCollectionItemEntriesInput, "folderId"> & ICreateFolderMutation;

export const createPropertyCollectionItemFolder = ({
  propertyId,
  collectionId,
  name,
  itemId,
  parentFolderId,
  id,
}: CreatePropertyCollectionItemFolderInput) => {
  return propelyApi()
    .post(`/properties/${propertyId}/collections/${collectionId}/items/${itemId}/folders`, {
      name,
      parentFolderId,
      id,
    })
    .then((response) => response.data);
};

export type UpdatePropertyCollectionItemFolderInput = PropertyCollectionItemEntriesInput & Omit<ICreateFolderMutation, "id">;

export const updatePropertyCollectionItemFolder = ({
  propertyId,
  collectionId,
  folderId,
  itemId,
  name,
  parentFolderId,
}: UpdatePropertyCollectionItemFolderInput) => {
  return propelyApi()
    .put(`/properties/${propertyId}/collections/${collectionId}/items/${itemId}/folders/${folderId}`, {
      name,
      parentFolderId,
    })
    .then((response) => response.data);
};

export type MovePropertyCollectionItemFileInput = PropertyCollectionItemEntriesInput & IMoveFilesMutation;

export const movePropertyCollectionItemFile = ({
  propertyId,
  collectionId,
  itemId,
  fileIds,
  folderId,
  previousFolderId,
}: MovePropertyCollectionItemFileInput) => {
  return propelyApi()
    .patch(`/properties/${propertyId}/collections/${collectionId}/items/${itemId}/files/move`, {
      previousFolderId,
      folderId,
      fileIds,
    })
    .then((response) => response.data);
};

export type DeletePropertyCollectionItemFolderInput = PropertyCollectionItemEntriesInput;

export const deletePropertyCollectionItemFolder = ({ propertyId, itemId, collectionId, folderId }: DeletePropertyCollectionItemFolderInput) => {
  return propelyApi()
    .delete(`/properties/${propertyId}/collections/${collectionId}/items/${itemId}/folders/${folderId}`)
    .then((response) => response.data);
};
